import s from '../../pages/info-page/styles.module.css';

export function FaceIcons({ styleSVG }) {
    return (
        <svg
            className={s[`${styleSVG}`]}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_3337_3775)">
                <path
                    d="M17.3027 21V19C17.3027 17.9391 16.8813 16.9217 16.1312 16.1716C15.381 15.4214 14.3636 15 13.3027 15H5.30273C4.24187 15 3.22445 15.4214 2.47431 16.1716C1.72416 16.9217 1.30273 17.9391 1.30273 19V21"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.30273 11C11.5119 11 13.3027 9.20914 13.3027 7C13.3027 4.79086 11.5119 3 9.30273 3C7.0936 3 5.30273 4.79086 5.30273 7C5.30273 9.20914 7.0936 11 9.30273 11Z"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLddinejoin="round"
                />
                <path
                    d="M23.3027 20.9999V18.9999C23.3021 18.1136 23.0071 17.2527 22.4641 16.5522C21.9211 15.8517 21.1609 15.3515 20.3027 15.1299"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.3027 3.12988C17.1631 3.35018 17.9258 3.85058 18.4704 4.55219C19.015 5.2538 19.3106 6.11671 19.3106 7.00488C19.3106 7.89305 19.015 8.75596 18.4704 9.45757C17.9258 10.1592 17.1631 10.6596 16.3027 10.8799"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3337_3775">
                    <rect width="24" height="24" fill="white" transform="translate(0.302734)" />
                </clipPath>
            </defs>
        </svg>
    );
}
